import { render } from "./ThongTinCapLenh.vue?vue&type=template&id=7709a1aa"
import script from "./ThongTinCapLenh.vue?vue&type=script&lang=js"
export * from "./ThongTinCapLenh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__